import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { usePopper } from 'react-popper';
import { RowTabStopContext, useRowTabIndex } from './row-tab-stop';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var TWPopover = function TWPopover(_ref) {
  var children = _ref.children,
    icon = _ref.icon,
    closeOnMouseLeave = _ref.closeOnMouseLeave,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? 'bg-gray-300' : _ref$backgroundColor,
    className = _ref.className,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
    onClickOpen = _ref.onClickOpen,
    triggerLabel = _ref.triggerLabel;
  var rowTabIndex = useRowTabIndex();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    referenceElement = _useState2[0],
    setReferenceElement = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    popperElement = _useState4[0],
    setPopperElement = _useState4[1];
  var _usePopper = usePopper(referenceElement, popperElement, {
      placement: placement,
      modifiers: [{
        name: 'flip',
        enabled: true,
        options: {
          flipVariations: true
        }
      }]
    }),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes;

  // A panel that a list row opens does not take the row's Tab stop state.
  var panelContent = /*#__PURE__*/_jsx(RowTabStopContext.Provider, {
    value: undefined,
    children: children
  });
  return /*#__PURE__*/_jsxs(Popover, {
    className: "relative",
    children: [/*#__PURE__*/_jsx(PopoverButton, {
      ref: setReferenceElement,
      "aria-label": triggerLabel,
      tabIndex: rowTabIndex,
      className: twMerge('hover:darken-10 focus-ring rounded-sm p-1', backgroundColor, className),
      onClick: onClickOpen,
      children: icon
    }), /*#__PURE__*/_jsx("div", {
      className: "relative h-full",
      children: /*#__PURE__*/_jsx(PopoverPanel, _objectSpread(_objectSpread({
        ref: setPopperElement,
        style: styles.popper
      }, attributes.popper), {}, {
        className: "relative z-50",
        children: function children(_ref2) {
          var close = _ref2.close;
          return /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(MouseLeaveHandler, {
              closeOnMouseLeave: closeOnMouseLeave,
              close: close
            }), panelContent]
          });
        }
      }))
    })]
  });
};
export default TWPopover;
var MouseLeaveHandler = function MouseLeaveHandler(_ref3) {
  var closeOnMouseLeave = _ref3.closeOnMouseLeave,
    close = _ref3.close;
  useEffect(function () {
    if (closeOnMouseLeave === false) {
      close();
    }
  }, [closeOnMouseLeave, close]);
  return /*#__PURE__*/_jsx("div", {});
};